module.exports = __webpack_public_path__ + "img/konst.c56219ff.jpg";